import React, { useState } from 'react';
import './PartnerStories.css';

const PartnerStories = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const stories = [
    {
      rating: 5,
      earnings: '₹65,000/month',
      testimonial: "मैंने कभी नहीं सोचा था कि मेरी आवाज़ इतनी valuable हो सकती है। अब मैं हर महीने ₹55,000 कमाता हूँ Hopmate पर!",
      author: 'Ayesha',
      role: 'Wellness Coach',
      initials: 'AS'
    },
    {
      rating: 5,
      earnings: '₹72,000/month',
      testimonial: 'I never thought I could earn this much just by having meaningful conversations. Hopmate changed my life completely!',
      author: 'Rajesh Kumar',
      role: 'Life Coach',
      initials: 'RK'
    },
    {
      rating: 5,
      earnings: '₹58,000/month',
      testimonial: 'The platform is amazing and the community is so supportive. I love being a Hopmate partner!',
      author: 'Priya Patel',
      role: 'Mental Health Advocate',
      initials: 'PP'
    }
  ];

  const currentStory = stories[currentIndex];

  const nextStory = () => {
    setCurrentIndex((prev) => (prev + 1) % stories.length);
  };

  const prevStory = () => {
    setCurrentIndex((prev) => (prev - 1 + stories.length) % stories.length);
  };

  return (
    <section className="partner-stories">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Partner Success Stories</h2>
          <p className="section-description">
            Hear from creators who transformed their passion into a thriving income
          </p>
        </div>
        <div className="testimonial-card">
          <div className="testimonial-rating">
            {[...Array(currentStory.rating)].map((_, i) => (
              <span key={i} className="star">★</span>
            ))}
          </div>
          <div className="testimonial-earnings">{currentStory.earnings}</div>
          <p className="testimonial-text">{currentStory.testimonial}</p>
          <div className="testimonial-author">
            <div className="author-avatar">{currentStory.initials}</div>
            <div className="author-info">
              <div className="author-name">{currentStory.author}</div>
              <div className="author-role">{currentStory.role}</div>
            </div>
          </div>
        </div>
        <div className="testimonial-nav">
          <button onClick={prevStory} className="nav-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button onClick={nextStory} className="nav-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <a 
          href="https://forms.gle/BqwhQXFZpfiouwds9" 
          target="_blank" 
          rel="noopener noreferrer"
          className="stories-cta-button"
        >
          Join Our Successful Partners
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default PartnerStories;

